import { ThunderDispatcher } from '../core/thunder-dispatcher.js';
export const dispatch_onClearWebsiteData = new ThunderDispatcher('__onClearWebsiteData');
//# sourceMappingURL=clearWebsiteDataDispatcher.js.map